import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
import { newGuid, pushAccessCode } from '@/configs/functions'
// import { storedUser } from '@/api/common/auth'
// const attachAccessCode = storedUser.getAttachAccessCode()+'&g='

// 附件访问地址
export const fileServer = (id: number, guid: string, fileName: string) => pushAccessCode(`${urlPrefix}/staticfile/show/${id}_${guid}/${encodeURIComponent(fileName)}?g=`+newGuid())
export const imgServer = (id: number, guid: string, fileName: string) => pushAccessCode(`${urlPrefix}/staticfile/pic/${id}_${guid}/${encodeURIComponent(fileName)}?g=`+newGuid())
export const thumbnailServer = (id: number, guid: string, fileName: string) => pushAccessCode(`${urlPrefix}/staticfile/thumbnail/${id}_${guid}/${encodeURIComponent(fileName)}`)//+newGuid()

//#region 附件api
//#region 上传
// 上传前的文件校验
export const CheckFile = `${urlPrefix}/upload/CheckFile`
// 文件/分块上传
export const ApiUploadFile = `${urlPrefix}/upload/UploadFile`
// 合并文件
export const MergeFile = `${urlPrefix}/upload/MergeFile`
//#endregion

export const uploadOptEty: UploadOptData = {
    isMulti: false,
    // .jpg.gif.png
    exts: '',
    refId: 0,
    refType: 0,
    guid: '',
}
export interface UploadData {
    [key: string]: any
    fileMd5: string
    chunkMd5: string
    chunk: number
    ext: string
    data: any // Request.Form.Files["file"]
}
export interface UploadCheckData {
    [key: string]: any
    FileMd5: string
    FileName: string
    Size: number
    Type: string
    ReferId: number
    ReferType: number
    TempGuid: string
}
export interface UploadMergeData {
    [key: string]: any
    ReferType: string
    TempGuid: string
    IsMulti: boolean
    FileMd5: string
    FileName: string
    Ext: string
    Type: string
}

// 上传需要的参数
export interface UploadOptData {
    isMulti: boolean
    // .jpg.gif.png
    exts: string
    refId: number
    refType: number
    guid: string
}

export const checkFile = (form: UploadCheckData) => {
    return tryAxios({
        method: 'post',
        url: CheckFile,
        data: form
    })
}

export const uploadFile = (form: UploadData) => {
    return tryAxios({
        method: 'post',
        url: ApiUploadFile,
        data: form
    })
}

export const mergeFile = (form: UploadMergeData) => {
    return tryAxios({
        method: 'post',
        url: MergeFile,
        data: form
    })
}
